import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { setToken, clearToken, getToken, formatApiError } from "@/lib/api";
import { mapUser } from "@/lib/adapt";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = anon, obj = user

  const refreshUser = useCallback(async () => {
    if (!getToken()) { setUser(false); return false; }
    try {
      const { data } = await api.get("/auth/me");
      const u = mapUser(data.user || data);
      setUser(u);
      return u;
    } catch {
      clearToken();
      setUser(false);
      return false;
    }
  }, []);

  useEffect(() => { refreshUser(); }, [refreshUser]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setToken(data.token);
    const u = mapUser(data.user);
    setUser(u);
    return u;
  };

  const register = async ({ email, password, name, gender, accountType, assistantRole }) => {
    const body = { email, password, displayName: name, gender };
    if (accountType) body.accountType = accountType;
    if (assistantRole) body.assistantRole = assistantRole;
    const { data } = await api.post("/auth/signup", body);
    setToken(data.token);
    const u = mapUser(data.user);
    setUser(u);
    return { user: u };
  };

  const logout = async () => {
    clearToken();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout, refreshUser, formatApiError }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
